import { render } from "./ModalDatosPropietario.vue?vue&type=template&id=310226bb&scoped=true"
import script from "./ModalDatosPropietario.vue?vue&type=script&lang=js"
export * from "./ModalDatosPropietario.vue?vue&type=script&lang=js"

import "./ModalDatosPropietario.vue?vue&type=style&index=0&id=310226bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310226bb"]])

export default __exports__